import React, { useState } from "react";

const MONTH_LOOKUP = {
    1: "ינואר",
    2: "פברואר",
    3: "מרץ",
    4: "אפריל",
    5: "מאי",
    6: "יוני",
    7: "יולי",
    8: "אוגוסט",
    9: "ספטמבר",
    10: "אוקטובר",
    11: "נובמבר",
    12: "דצמבר"
};
import "react-block-ui/style.css";
import { Loader } from "react-loaders";
import "loaders.css/loaders.min.css";
import { Table, Button, Form } from "react-bootstrap";
import Select from "../components/Select";
import moment from "moment-timezone";
import Api from "../utils/Api";

const monthOptions = Object.keys(MONTH_LOOKUP).map((id) => {
    return { id: id, description: `${MONTH_LOOKUP[id]} - ${id}` };
});

export default function MonthCompare(props) {
    const cardStyle = {
        background: "white",
        boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
        borderRadius: "10px"
    };

    const [firstMonth, setFirstMonth] = useState(moment().month().toString());
    const [secondMonth, setSecondMonth] = useState((moment().month() + 1).toString());
    const [items, setItems] = useState([]);
    const [totals, setTotals] = useState({});

    const compare = async () => {
        const params = {
            firstMonth,
            secondMonth
        };

        let queryString = new URLSearchParams();
        for (let key in params) {
            queryString.append(key, params[key]);
        }
        const { response } = await Api.monthComparison(params);
        setItems(
            response.monthDetails.sort((a, b) => {
                return b.currentMonthAmount - a.currentMonthAmount;
            })
        );
        setTotals({
            expenseCategoriesSum: response.expenseCategoriesSum,
            compareExpenseCategoriesSum: response.compareExpenseCategoriesSum,
            totalDiff: response.totalDiff,
            totalDiffInPercentage: response.totalDiffInPercentage
        });
    };
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center"
            }}
        >
            <div
                style={{
                    borderRadius: "10px",
                    direction: "rtl",
                    width: "100%",
                    background: "#e6e6e6"
                }}
            >
                <div
                    style={{
                        boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                        borderRadius: "10px",
                        margin: "auto",
                        marginTop: "40px",
                        display: "flex",
                        width: "50%",
                        justifyContent: "center",
                        justifySelf: "center",
                        // position: "fixed",
                        // top: 44,
                        // zIndex: 900,
                        background: "white"
                    }}
                >
                    <Form.Group className="mb-3" controlId="formBasicEmail" style={{ width: "200px", margin: "20px" }}>
                        <Form.Label>חודש 1</Form.Label>
                        <Select
                            options={monthOptions}
                            multi={false}
                            selected={firstMonth}
                            onSelect={setFirstMonth}
                            placeholder="בחר חודש"
                            isSearchable={false}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicEmail" style={{ width: "200px", margin: "20px" }}>
                        <Form.Label>חודש 2</Form.Label>
                        <Select
                            options={monthOptions}
                            multi={false}
                            selected={secondMonth}
                            onSelect={setSecondMonth}
                            placeholder="בחר חודש"
                            isSearchable={false}
                        />
                    </Form.Group>
                    <Button
                        style={{
                            marginRight: "20px",
                            background: "rgb(255, 102, 102)",
                            borderRadius: "17px",
                            borderColor: "rgb(255, 102, 102)",
                            height: "50px",
                            alignSelf: "center"
                        }}
                        variant="primary"
                        type="submit"
                        onClick={compare}
                    >
                        {" "}
                        השווה{" "}
                    </Button>
                </div>

                {items?.length ? (
                    <div
                        style={Object.assign({}, cardStyle, {
                            display: "flex",
                            width: "50%",
                            margin: "auto",
                            marginTop: "40px"
                        })}
                    >
                        <Table style={{ width: "80%", margin: "auto" }}>
                            <thead>
                                <tr>
                                    <th style={{ width: "150px" }}>קטגוריה</th>
                                    <th style={{ width: "100px" }}>{`${MONTH_LOOKUP[firstMonth]} - ${firstMonth}`}</th>
                                    <th
                                        style={{ width: "100px" }}
                                    >{`${MONTH_LOOKUP[secondMonth]} - ${secondMonth}`}</th>
                                    <th style={{ width: "100px" }}>הפרש</th>
                                    <th style={{ width: "100px" }}>%</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.map((item) => {
                                    return (
                                        <tr>
                                            <td style={{ fontWeight: "bold" }}>{item.description}</td>
                                            <td>{item.compareMonthAmount}</td>
                                            <td>{item.currentMonthAmount}</td>
                                            <td
                                                style={{
                                                    direction: "ltr",
                                                    textAlign: "right"
                                                }}
                                            >
                                                {item.diff}
                                            </td>
                                            <td
                                                style={{
                                                    direction: "ltr",
                                                    textAlign: "right"
                                                }}
                                            >
                                                {item.diffInPercentage}
                                                {item.diffInPercentage ? "%" : ""}
                                            </td>
                                        </tr>
                                    );
                                })}
                                <tr>
                                    <td style={{ fontWeight: "bold" }}>{"סה״כ"}</td>
                                    <td style={{ fontWeight: "bold" }}>{totals.compareExpenseCategoriesSum}</td>
                                    <td style={{ fontWeight: "bold" }}>{totals.expenseCategoriesSum}</td>
                                    <td
                                        style={{
                                            direction: "ltr",
                                            textAlign: "right",
                                            fontWeight: "bold"
                                        }}
                                    >
                                        {totals.totalDiff}
                                    </td>
                                    <td
                                        style={{
                                            direction: "ltr",
                                            textAlign: "right",
                                            fontWeight: "bold"
                                        }}
                                    >
                                        {totals.totalDiffInPercentage}%
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                ) : (
                    <div />
                )}
            </div>
        </div>
    );
}
